import type { ReactNode } from "react";

interface PageHeaderProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  right?: ReactNode;
}

export function PageHeader({
  eyebrow = "Model Monitoring",
  title,
  subtitle,
  right,
}: PageHeaderProps) {
  return (
    <header className="w-full border-b border-border pt-0 pb-0">
      <div className="flex items-start justify-between gap-6">
        <div className="min-w-0">
          <h1 className="text-2xl font-semibold tracking-tight">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-2 max-w-3xl text-sm text-muted-foreground">
              {subtitle}
            </p>
          )}
        </div>
        {right && <div className="shrink-0">{right}</div>}
      </div>
    </header>
  );
}
